import type { PaymentMethod } from '@ahm/api-wrappers-core';
import { session } from '@ahm/common-helpers';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logger } from '@/stores/logger';
import { createSelectors } from '@/stores/selectors';

type CheckoutState = {
  checkoutPaymentMethod: PaymentMethod | null;
  checkedTerms: boolean;
};

type CheckoutActions = {
  setCheckoutPaymentMethod: (paymentMethod: PaymentMethod | null) => void;
  setCheckedTerms: (checkedTerms: boolean) => void;
};

const CHECKOUT_STORE_NAME = 'ahm.checkout';

const store = create<
  CheckoutState & CheckoutActions,
  [
    ['zustand/devtools', CheckoutState & CheckoutActions],
    ['zustand/persist', CheckoutState],
  ]
>(
  logger(
    devtools(
      persist(
        (set) => {
          return {
            checkoutPaymentMethod: null,
            checkedTerms: true,
            setCheckoutPaymentMethod: (paymentMethod: PaymentMethod) => {
              set({ checkoutPaymentMethod: paymentMethod });
            },
            setCheckedTerms: (checkedTerms: boolean) => {
              set({ checkedTerms });
            },
          };
        },
        {
          name: CHECKOUT_STORE_NAME,
          storage: createJSONStorage(() => session),
        }
      )
    ),
    CHECKOUT_STORE_NAME
  )
);

export const useCheckoutStore = createSelectors(store);
